import React from 'react';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';


const SearchBar = ({ searchQuery, onSearchChange, onSearch, onToggleFilters }) => {
  const handleSubmit = (e) => {
    e?.preventDefault();
    onSearch();
  };

  return (
    <form onSubmit={handleSubmit} className="w-full">
      <div className="flex flex-col sm:flex-row gap-2 md:gap-3">
        <Button
          type="button"
          variant="outline"
          onClick={onToggleFilters}
          className="sm:hidden"
          iconName="SlidersHorizontal"
          iconPosition="left"
        >
          Filters
        </Button>
        <div className="flex-1">
          <Input
            type="search"
            placeholder="Search by job title, company, or keywords..."
            value={searchQuery}
            onChange={(e) => onSearchChange(e?.target?.value)}
            className="mb-0"
          />
        </div>
        <Button
          type="submit"
          variant="default"
          iconName="Search"
          iconPosition="left"
          className="sm:w-auto"
        >
          Search
        </Button>
      </div>
    </form>
  );
};

export default SearchBar;